import { makeForm } from 'nike-form-js';
import { useEffect, useState } from 'react';
import { Map } from 'immutable';
import { useFormSubmit } from '../../../registration/hook/useForm';
import { formValidator, MULTI } from './validators';
import { dispatch } from 'nike-re-framejs';
import { createDefaultKycAnswer, createKycAnswer } from '../../reframe/h&s';
import { KYC_QUESTION_TYPE } from './KycQuestionType';

function onSubmitDefaultForm(formValues, form) {
    const createAnswerKycArray = getAnswerKycArray(formValues);
    dispatch(createDefaultKycAnswer(createAnswerKycArray, form));
}

function onSubmit(formValues, form) {
    const createAnswerKycArray = getAnswerKycArray(formValues);
    dispatch(createKycAnswer(createAnswerKycArray, form));
}

function getAnswerKycArray(formValues) {
    let createAnswerKycArray = [];
    formValues.mapKeys((type, kyc) => {
        if (type === KYC_QUESTION_TYPE.MULTI) {
            kyc?.mapKeys((question_id, options) => {
                const resultMulti = submitMulti(question_id, options);
                createAnswerKycArray.push(...resultMulti);
            });
        }
        if (type === KYC_QUESTION_TYPE.FREETEXT) {
            kyc?.mapKeys((question_id, options) => {
                const result = submitFreeText(question_id, options);
                createAnswerKycArray.push(...result);
            });
        }
        if (type === KYC_QUESTION_TYPE.SINGLE) {
            kyc?.mapKeys((question_id, options) => {
                const result = { question_id, option_id: options };
                createAnswerKycArray.push(result);
            });
        }
    });
    return createAnswerKycArray;
}

function submitMulti(question_id, options) {
    const multiCheckbox = options
        .filter(option => option.getIn(MULTI.CHECKBOX))
        .keySeq()
        .toArray()
        .map(option_id => ({
            question_id,
            option_id
        }));

    const multiFreetext = options
        .filter(option => option.getIn(MULTI.CHECKBOX))
        .entrySeq()
        .flatMap(([question_id, freetext]) => multiFreetextJoin(question_id, freetext));

    return [...multiCheckbox, ...multiFreetext];
}
function multiFreetextJoin(question_id, freetext) {
    return [...(freetext.get(...MULTI.FREETEXT)?.entries() ?? [])].map(([option_id, option_freetext]) => ({
        question_id,
        option_id,
        option_freetext
    }));
}

function submitFreeText(question_id, options) {
    return [...options.entries()].map(([option_id, value]) => ({
        question_id,
        option_id,
        option_freetext: value.get('freetext')
    }));
}

function useForm(version, maxAnswerNum = 4) {
    const [form, setForm] = useState(() =>
        makeForm(Map(), {
            validator: formValidator(maxAnswerNum)
        })
    );

    useEffect(() => {
        const newForm = makeForm(Map(), {
            validator: formValidator(maxAnswerNum)
        });
        setForm(newForm);
    }, [maxAnswerNum]);

    const onSubmitFn = version === 'default' ? onSubmitDefaultForm : onSubmit;
    return [form, useFormSubmit(form, onSubmitFn)];
}

export default useForm;
